<template>
  <div class="app-container">
    <el-form class="demo-ruleForm" label-position="top" size="medium">
      <div style="display: inline-block; margin-right: 100px;">
        <el-form-item label="商用能耗电费用配置" style="margin-bottom: 50px">
        <el-input-number
          style="min-width: 202px"
          :precision="2"
          v-model="energy_electricity.unit_price"
          :min="0"
          :max="300"
          label="电费设置"
        ></el-input-number>
        / 度
      </el-form-item>
      <el-form-item label="商用水费" style="margin-bottom: 50px">
        <el-input-number
          style="min-width: 202px"
          :precision="2"
          v-model="energy_water.unit_price"
          :min="0"
          :max="300"
          label="能耗水费用配置"
        ></el-input-number>
        / 吨
      </el-form-item>
      </div>
      <div style="display: inline-block;">
        <el-form-item label="住宅能耗电费用配置" style="margin-bottom: 50px">
        <el-input-number
          style="min-width: 202px"
          :precision="2"
          v-model="energy_electricity.house_unit_price"
          :min="0"
          :max="300"
          label="电费设置"
        ></el-input-number>
        / 度
      </el-form-item>
      <el-form-item label="住宅水费" style="margin-bottom: 50px">
        <el-input-number
          style="min-width: 202px"
          :precision="2"
          v-model="energy_water.house_unit_price"
          :min="0"
          :max="300"
          label="能耗水费用配置"
        ></el-input-number>
        / 吨
      </el-form-item>
      </div>
      <el-form-item>
        <el-button
          type="success"
          @click="editForm"
          v-if="roles.includes('/energy/set_config')"
        >
          修改
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getConfig, setConfig } from "@/api/energy";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  data() {
    return {
      energy_electricity: { unit_price: 0.00,house_unit_price:0.00 },
      energy_water: { unit_price: 0.00,house_unit_price:0.00},
    };
  },
  created() {
    this.getinfo();
  },
  mounted() {},
  methods: {
    getinfo() {
      var that = this;
      getConfig({ keys: "energy_electricity,energy_water" }).then((res) => {
        res.data.lists.forEach((item, index) => {
          
          if (item.key == "energy_water") {
            that.energy_water = item.value;
          } else if (item.key == "energy_electricity") {
            that.energy_electricity = item.value;
          }
        });
      });
    },
    editForm() {
      let data = {
        energy_electricity: JSON.stringify(this.energy_electricity),
        energy_water: JSON.stringify(this.energy_water),
      };
      setConfig(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  padding: 30px;
}
</style>
